import Link from "ds/components/Link";
import SpaceliftLogo from "ds/components/SpaceliftLogo/Logo";
import { trackSegmentEvent } from "shared/Analytics";

const MainNavigationLogo = () => {
  return (
    <Link
      onPress={() => trackSegmentEvent("Spacelift logo click")}
      href="/"
      aria-label="Spacelift homepage"
      noEllipsis
    >
      <SpaceliftLogo size="small" />
    </Link>
  );
};

export default MainNavigationLogo;
